import React from 'react';
export const ParentsStory = () => {
  return <div className="py-8" data-id="element-159">
      <div className="prose max-w-none" data-id="element-160">
        <h2 className="text-3xl font-bold mb-6 text-green-700" data-id="element-161">
          När jag introducerade Nourix för min mamma
        </h2>
        <div className="flex flex-col md:flex-row gap-8 items-center mb-8" data-id="element-162">
          <div className="md:w-1/2" data-id="element-163">
            <p className="text-lg mb-4" data-id="element-164">
              I mars åkte jag hem till Västerås för att fira mammas 55-årsdag.
              Det var första gången på nästan två månader som min mamma såg mig,
              och reaktionen var omedelbar. Mamma omfamnade mig i dörren och tog
              sedan ett steg tillbaka, granskade mig från topp till tå och
              utbrast: "Sofia, vad har hänt med dig? Du ser fantastisk ut!"
            </p>
            <p className="text-lg mb-4" data-id="element-165">
              Hon hade sett mig kämpa med vikten i flera år och var nyfiken på
              vad som var annorlunda den här gången.
            </p>
            <p className="text-lg mb-4" data-id="element-166">
              Jag hade tagit med mig min burk med Nourix för att visa henne.
              Till skillnad från tidigare när jag entusiastiskt berättat om nya
              dieter jag testade, var jag nu mer avslappnad. Jag förklarade att
              det inte handlade om en strikt diet utan om att hjälpa kroppen att
              hitta sin naturliga balans.
            </p>
          </div>
          <div className="md:w-1/2" data-id="element-167">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/89spFp23fXeAeUXhRFbVii/image.png?vasteras=true&t=1" alt="Västerås, där jag introducerade Nourix för min mamma" className="w-full h-auto rounded-lg shadow-md" loading="eager" fetchpriority="high" data-id="element-168" />
            <p className="mt-2 text-center text-sm italic" data-id="element-169">
              Västerås - staden där jag introducerade min mamma för Nourix
            </p>
          </div>
        </div>
        <p className="text-lg mb-4" data-id="element-170">
          Under middagen berättade jag mer detaljerat om min upplevelse - inte
          bara om viktminskningen utan om hur min energi hade förändrats, hur
          mitt sötsug hade minskat och hur jag sov bättre än jag gjort på år.
        </p>
        <p className="text-lg mb-4" data-id="element-171">
          Min mamma, som är i 50-årsåldern, hade också kämpat med vikten de
          senaste åren. Hon hade börjat få problem med ledvärk, särskilt i
          knäna, vilket gjorde det svårt för henne att vara aktiv. Hon var
          skeptisk i början - precis som jag hade varit - men efter att ha sett
          min förändring blev hon nyfiken.
        </p>
        <div className="my-8 flex justify-center" data-id="element-172">
          <div className="relative w-2/3 md:w-1/2" data-id="element-173">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/313wL5L7YVrPJRC5ZAQA5n/foremamma.png?before=true&t=1" alt="Mamma innan hon började med Nourix" className="w-full h-auto rounded-lg shadow-md filter grayscale" loading="eager" fetchpriority="high" data-id="element-174" />
            <div className="absolute top-0 left-0 bg-red-500 text-white py-1 px-3 rounded-br-lg rounded-tl-lg font-bold" data-id="element-175">
              FÖRE
            </div>
          </div>
        </div>
        <p className="mt-3 text-center italic" data-id="element-176">
          Mamma innan hon började med Nourix - trött och utan energi
        </p>
        <h3 className="text-2xl font-semibold mt-8 mb-4 text-green-700" data-id="element-177">
          Mammas resultat överraskade oss båda
        </h3>
        <p className="text-lg mb-4" data-id="element-178">
          Efter att ha sett min förändring bestämde sig mamma för att prova
          Nourix. Hon beställde en förpackning och började ta det dagligen
          enligt rekommendationerna.
        </p>
        <p className="text-lg mb-4" data-id="element-179">
          Vi skapade en familjechat där vi kunde dela våra erfarenheter och
          stötta varandra. Det var faktiskt riktigt roligt - mamma skickade mig
          uppdateringar varje vecka om hur hon kände sig och delade bilder på
          måltider hon lagade.
        </p>
        <p className="text-lg mb-4" data-id="element-180">
          Efter bara en månad ringde mamma mig, upprymd. Hon hade märkt att
          hennes morgonstelhet hade minskat avsevärt, och hon hade mer energi
          under dagen. Hon hade börjat gå på promenader igen, något hon hade
          undvikit på grund av smärta i knäna. "Det känns som om någon har
          smörjt mina leder", sa hon och skrattade.
        </p>
        <div className="my-8 flex justify-center" data-id="element-181">
          <div className="relative w-2/3 md:w-1/2" data-id="element-182">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/eWQDRCgTkFJmJ3LDusFY9p/db41e42f-49f9-4411-91d2-3150acb985ea.png?after=true&t=1" alt="Mamma efter tre månader med Nourix" className="w-full h-auto rounded-lg shadow-md" loading="eager" fetchpriority="high" data-id="element-183" />
            <div className="absolute top-0 left-0 bg-green-500 text-white py-1 px-3 rounded-br-lg rounded-tl-lg font-bold" data-id="element-184">
              EFTER
            </div>
          </div>
        </div>
        <p className="mt-3 text-center italic" data-id="element-185">
          Mamma efter tre månader med Nourix - pigg och full av energi på
          promenad i skogen
        </p>
        <p className="text-lg mb-4" data-id="element-186">
          Efter tre månader hade mamma gått ner 8 kilo. Men det bästa av allt
          var att hennes ledvärk hade minskat markant. Hon kände sig yngre och
          piggare än på länge.
        </p>
        <p className="text-lg mb-4" data-id="element-187">
          Vid midsommarfirandet i år kommenterade flera släktingar hur bra vi
          båda såg ut, och vi skrattade när vi berättade att det var samma
          produkt som hade hjälpt oss. Min moster blev så intresserad att hon
          också beställde Nourix samma kväll!
        </p>
        <h3 className="text-2xl font-semibold mt-10 mb-4 text-green-700" data-id="element-188">
          Min fullständiga förvandling - mer än bara viktnedgång
        </h3>
        <div className="flex flex-col md:flex-row gap-6 my-8 items-center" data-id="element-189">
          <div className="md:w-1/2" data-id="element-190">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/4hRBd7SoFhxazr5d2B1kZN/gladkv.png?morning=true&t=1" alt="Glad kvinna på morgonen" className="w-full h-auto rounded-lg shadow-md" loading="eager" fetchpriority="high" data-id="element-191" />
            <p className="mt-2 text-center italic" data-id="element-192">
              Efter bara två veckor började jag vakna utvilad och pigg
            </p>
          </div>
          <div className="md:w-1/2" data-id="element-193">
            <p className="text-lg mb-4" data-id="element-194">
              Det första jag märkte efter att ha tagit Nourix i ungefär en vecka
              var att jag sov bättre. Jag hade länge haft problem med orolig
              sömn, där jag vaknade flera gånger under natten och kände mig
              trött på morgonen. Men nu sov jag djupare och vaknade faktiskt
              utvilad.
            </p>
            <p className="text-lg mb-4" data-id="element-195">
              Efter ungefär två veckor märkte jag att eftermiddagströttheten
              började försvinna. Normalt brukade jag vara helt slut runt klockan
              15 och behövde kaffe och något sött för att orka med resten av
              arbetsdagen. Nu kunde jag fokusera hela dagen utan att känna mig
              utmattad.
            </p>
          </div>
        </div>
        <p className="text-lg mb-4" data-id="element-196">
          Det mest överraskande var hur mitt sötsug förändrades. Jag hade alltid
          varit en "sockermänniska" som kunde äta en hel chokladkaka på en gång.
          Men efter några veckor med Nourix märkte jag att jag inte längre hade
          samma intensiva begär efter sötsaker. Jag kunde faktiskt ha choklad
          hemma utan att äta upp allt på en gång!
        </p>
        <div className="bg-green-50 p-6 rounded-lg border border-green-100 my-8" data-id="element-197">
          <h4 className="text-xl font-semibold mb-3 text-green-700" data-id="element-198">
            Vad jag märkte efter en månad med Nourix:
          </h4>
          <ul className="list-disc pl-6 space-y-2 text-lg" data-id="element-199">
            <li data-id="element-200">Bättre och djupare sömn - vaknade utvilad</li>
            <li data-id="element-201">Mer energi under hela dagen</li>
            <li data-id="element-202">Betydligt minskat sötsug</li>
            <li data-id="element-203">Mindre uppblåsthet efter måltider</li>
            <li data-id="element-204">Stabilare humör utan de vanliga svängningarna</li>
            <li data-id="element-205">Gradvis viktminskning utan att känna mig hungrig</li>
          </ul>
        </div>
        <p className="text-lg mb-4" data-id="element-206">
          Efter en månad hade jag gått ner nästan 4 kilo, men det var faktiskt
          inte det som gjorde mig mest glad. Det var energin och det mentala
          välbefinnandet som verkligen förändrade min vardag. Jag började se
          fram emot morgondagen istället för att känna ångest över allt jag
          behövde göra men inte hade ork till.
        </p>
        <div className="flex flex-col md:flex-row gap-6 my-8 items-center" data-id="element-207">
          <div className="md:w-1/2" data-id="element-208">
            <p className="text-lg mb-4" data-id="element-209">
              En annan positiv förändring var att jag började känna mig sugen på
              att röra på mig. Tidigare var träning något jag tvingade mig till
              för att "bränna kalorier", men nu började jag känna en naturlig
              lust att vara aktiv. Jag började ta promenader på lunchen och till
              och med anmälde mig till en yogaklass - något jag inte hade orkat
              med på flera år.
            </p>
            <p className="text-lg mb-4" data-id="element-210">
              Min kollega Maria var den första som kommenterade förändringen.
              "Du ser så pigg ut nuförtiden", sa hon en dag när vi åt lunch.
              "Har du gjort något annorlunda?" Jag berättade försiktigt om
              Nourix, och till min förvåning blev hon genuint intresserad
              istället för skeptisk.
            </p>
          </div>
          <div className="md:w-1/2" data-id="element-211">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/8q55xy18iHmnXPH9pyw7Pp/yoga.png?yogaclass=true&t=1" alt="Kvinna på yogaklass" className="w-full h-auto rounded-lg shadow-md" loading="eager" fetchpriority="high" data-id="element-212" />
            <p className="mt-2 text-center italic" data-id="element-213">
              För första gången på år kände jag mig motiverad att börja med yoga
              igen
            </p>
          </div>
        </div>
        <p className="text-lg mb-4" data-id="element-214">
          Efter tre månader hade jag gått ner 11 kilo totalt, men det kändes
          inte som en diet. Jag åt när jag var hungrig, njöt av maten, och kände
          mig mätt och tillfredsställd. Det var som om min kropp äntligen hade
          hittat sin naturliga balans.
        </p>
        <div className="my-8 flex justify-center" data-id="element-215">
          <div className="w-full md:w-2/3" data-id="element-216">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/wfUxsG2WUQ5mAV1g468P4F/image.png?product=nourix&t=1" alt="Kvinna visar upp Nourix-förpackningen vid en flod med en vän i bakgrunden" className="w-full h-auto rounded-lg shadow-md" loading="eager" fetchpriority="high" data-id="element-217" />
            <p className="mt-3 text-center italic" data-id="element-218">
              Nourix - produkten som förändrade allt för mig och min mamma
            </p>
          </div>
        </div>
        <div className="bg-green-50 p-6 rounded-lg border border-green-100 my-8" data-id="element-219">
          <p className="text-lg font-medium text-green-800 mb-2" data-id="element-220">
            "För första gången har jag hittat något som faktiskt fungerar. Det
            är inte en tillfällig diet utan en förändring i hur min kropp
            fungerar." - Mamma
          </p>
        </div>
        <p className="text-lg italic" data-id="element-221">
          Om du funderar på att prova Nourix, rekommenderar jag att du tar deras
          quiz först för att se om det kan passa dig. Du hittar det{' '}
          <a href="https://www.clickrtrckr.com/5CXCQDK/42BXCKW/" target="_blank" rel="noopener noreferrer" className="text-green-700 underline" data-id="element-222">
            här
          </a>
          .
        </p>
      </div>
    </div>;
};